import fs from 'node:fs'
import { snapshotRoot } from './snapshot-root.js'

export function snapshotRootExists(cwd: string): boolean {
  return fs.existsSync(snapshotRoot(cwd))
}
